import type { HTMLAttributes, PropsWithChildren } from "react";

import type { TIconKey } from "@/ui/components/primitives/Icon";
import type { DefinedDefaults } from "@/ui/lib/types";
import { cn } from "@/ui/lib/utils";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const DISCOUNT_TAG_CLASS_NAME = cn(
  "inline-flex !mx-0 !w-fit !max-w-[321px] items-center gap-1.5",
  "rounded-sys-sm border border-solid px-2 py-1 shadow-xs",
  "border-sys-green-600 bg-sys-green-100 text-functional-success",
);

export const DISCOUNT_TAG_ICON_CLASS_NAME = cn(
  "h-5 w-5 shrink-0 text-sys-green-700",
);

/*-------------------------------------
|  Types
-------------------------------------*/

export type TDiscountTagProps = {
  icon?: TIconKey;
} & PropsWithChildren & HTMLAttributes<HTMLDivElement>;

type TDiscountTagDefaultProps = DefinedDefaults<TDiscountTagProps, "icon">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const DISCOUNT_TAG_DEFAULTS = {
  icon: "tag",
} satisfies TDiscountTagDefaultProps;
